import { Image, Text, View } from '@react-pdf/renderer';

import SalesComparisonRow from '../components/SalesComparisonRow.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { salesComparisonColumns } from '../constants.ts';
import { salesComparisonPageStyles as styles } from '../styles.ts';
import { SalesComparisonGridColumnData, SalesComparisonPageProps } from '../types.ts';

export const SalesComparisonPage = ({
  subjectAddress,
  subjectSalesComparisonData,
  comparables,
}: SalesComparisonPageProps) => {
  // Group comparables into chunks of 3 per page
  const compsPerPage = 3;
  const pages: SalesComparisonGridColumnData[][] = [];
  for (let i = 0; i < comparables.length; i += compsPerPage) {
    pages.push(comparables.slice(i, i + compsPerPage));
  }

  return (
    <>
      {pages.map((chunk, pageIndex) => (
        <Tkv2PDFPage
          key={`sales-comparison-page-${pageIndex}`}
          title="Sales Comparison"
          address={subjectAddress}
        >
          <View style={styles.content}>
            <View style={styles.row}>
              {[subjectSalesComparisonData, ...chunk].map((comp, i) => (
                <View style={styles.gridColumn} key={`scc-card-${comp?.address}`}>
                  <View>
                    <Text style={styles.header}>
                      {i === 0 ? 'Subject Property' : `Comparable ${i + pageIndex * compsPerPage}`}
                    </Text>
                  </View>
                  <View style={styles.imageContainer}>
                    {comp?.imageUrl && <Image src={comp.imageUrl} style={styles.image} />}
                  </View>
                </View>
              ))}
            </View>

            <View style={styles.row}>
              {[subjectSalesComparisonData, ...chunk].map((comp) => (
                <View
                  style={{ ...styles.gridColumn, ...styles.addressContainer }}
                  key={`scc-address-${comp?.address}`}
                >
                  <Text style={styles.address}>{comp?.address}</Text>
                </View>
              ))}
            </View>

            {salesComparisonColumns.map((field) => (
              <SalesComparisonRow
                key={`scc-field-${field.key[0]}`}
                fields={field.key as (keyof SalesComparisonGridColumnData)[]}
                labels={field.label}
                subject={subjectSalesComparisonData as SalesComparisonGridColumnData}
                comparables={chunk}
                adjustment={field.adjustment as keyof SalesComparisonGridColumnData}
                borderTop={field.borderTop}
                bold={field.bold}
                align={(field.align as 'left' | 'right' | 'center') || 'left'}
              />
            ))}
          </View>
        </Tkv2PDFPage>
      ))}
    </>
  );
};
